import { getInstance, DOMAIN_ENV } from '@finance/domain'
import { APP, RUN_APP } from '@common/loan-act/env'
import useragent from '@finance/useragent'
import collect from '@common/collect'
import store from '@/stores/index'
import { windowOpen } from '@common/loan-act/util'
// import { call } from '@common/client/src/bridge'
import collectDataExt from '@/utils/collectDataExt'
import { loginByGetUserInfo } from '@/utils/client'

// 当前环境
export const ENV = getInstance().env

// 是否正式环境
export const isPROD = ENV.indexOf('prod') !== -1

export const isUAT = ENV.indexOf('uat') !== -1

// 微信H5支付
export const WECHAT_H5_PAY = 1
// 苹果支付
export const APPLE_PAY = 2
// 华为支付
export const HUAWEI_PAY = 4
// 微信app支付
export const WX_APP_PAY = 7

/** app内部自动识别code */
export const ACT_CODE = (() => {
  const code = {
    [APP.ssj]: 'ad_free',
    [APP.kn]: 'ad_free'
  }
  return code[RUN_APP]
})()

// 默认创建账本id
const getDefaultBookTemplateId = () => {
  switch (ENV) {
    case DOMAIN_ENV.PROD:
    case DOMAIN_ENV.OUTER_PROD:
    case DOMAIN_ENV.FEIDEE_PROD:
    case DOMAIN_ENV.UAT:
      return '595573797749784577'
    default:
      return '435808876174688257'
  }
}
export const DEFAULT_BOOK_TEMPLATE_ID = getDefaultBookTemplateId()

// todo 根据每次活动进行修改
export const PAGE_NAME = '看视频落地页'
export const PAGE_NAME_B = '看视频中间页'

/**
 * 埋点初始化函数
 * @param parmas
 */
export const collectInit = (parmas: CollectInit) => {
  const { pageName, baidu, ga } = parmas
  const { account = '', guestAccount = '' } = store.state.common.profile
  collect.init({
    baidu: baidu || false, // 是否引入百度统计代码！默认引入，不引入可以配置为false
    ga: ga || false, // 是否引入GA统计代码！默认引入，不引入可以配置为false
    flowName: 'recommend', // 默认值是‘finance’，一般情况下不需要修改
    pageName, // 页面标题，例如基金首页，可以配置为“基金首页”,
    commonsStatic: {
      departmentID: 'community',
      businessID: 'recommend',
      uid: account || guestAccount
    },
    eventsStatic: collectDataExt()
  })
  const { trackView, trackEvent } = collect
  collect.trackView = (title = '', params = {}, customJson = {}) => {
    trackView(title, params, { action: title, ...customJson })
  }
  collect.trackEvent = (title = '', params = {}, customJson = {}) => {
    trackEvent(title, params, { action: title, ...customJson })
  }
}

/**
 * 创建账本必须上报埋点
 * @param book 账本
 */
export const createBookTrack = (parmas: { bookId: string, bookTemplateId: string}) => {
  if (parmas) {
    const { bookId, bookTemplateId } = parmas
    collect.trackView('创建账本成功', {}, {
      ext_value: JSON.stringify({
        dfrom_type: '默认',
        book_type: '神象云',
        storeId: bookTemplateId,
        syncId: bookId,
        product_type: '账本管理',
        book_source: `运营活动_${PAGE_NAME}`
      })
    })
  }
}

export const trackLeavePage = (pagName:string, entryTime?: number) => {
  const now = new Date().getTime()
  const t = entryTime || window._pageTimeOp
  collect.trackView(`${pagName}_离开`, {}, {
    etype: 'leave',
    time_op: now - t
  })
}

export const jumpHandler = (url: string, type?: string) => {
  const path = encodeURIComponent(url)
  let linkType = type || ''
  if (url && url.indexOf('t.feidee') === -1 && useragent.isSuishouji) {
    linkType = 'finance'
  } else if (url && url.indexOf('t.cardniu') === -1 && useragent.isKaniu) {
    linkType = 'applycard'
  }
  switch (linkType) {
    // 随手记小程序
    // case 'weapp':
    //   window.location.href = `https://t.feidee.com/launchMiniProgram?userName=${weappID}&path=${path}`
    //   break
    // 卡牛小程序
    // case 'knweapp':
    //   window.location.href = `https://t.cardniu.com/wechatMiniProgram?userName=${weappID}&path=${path}`
    //   break
    // 随手记-理财容器
    case 'finance':
      window.location.href = `https://t.feidee.com/financeWeb?url=${path}`
      break
    // 卡牛-办卡容器
    case 'applycard':
      window.location.href = `https://t.cardniu.com/applycard?url=${path}`
      break
    // 随手记-客服
    case 'service':
      window.location.href = `https://t.feidee.com/wxCustomerService?corpId=ww4ef6780d1fe31a5f&url=${path}`
      break
    default:
      url && (window.location.href = url)
      break
  }
}

/**
 * 登录并回调
 */
export const actLogin = ({ needBindPhone = true } = {}) => {
  const params = useragent.isIOS ? { needLogin: 5, showSkip: 1 } : { needLogin: 2, showSkip: 0 }

  return new Promise((resolve, reject) => {
    loginByGetUserInfo(params)
      .then((result: any) => {
        if (needBindPhone && !result.phone) {
          useragent.isIOS ? loginByGetUserInfo({ needLogin: 6, showSkip: 1 }) : (window.location.href = 'https://t.feidee.com/bindPhone')
          return
        }
        resolve(result)
      }).catch(reject)
  })
}

// 挽留弹窗code
export const OPRATION_POPUP_CODE = 'retention_popup_gold_card_not_opened'
// 常见问题地址
export const COMMON_PROBLEM_URL = isPROD || isUAT ? 'https://m.feidee.com/sui-m/book-detail/index.html?isCloud=true&env=prod&id=828218420599750657&type=0'
  : 'https://frontend.feidee.cn/money/book-detail/index.html?isCloud=true&env=test5&id=828695964490821632&type=0'

// 客服地址
export const AD_FREE_SERVICE = 'https://work.weixin.qq.com/kfid/kfc05663a5a28e7eaee'
export const KN_SERVICE_URL = 'https://work.weixin.qq.com/kfid/kfc639dfeba790e623d'

/**
 * 跳转至客服
 */
export const jumpServiceUrl = () => {
  if (useragent.isSuishouji) {
    window.location.href = `https://t.feidee.com/wxCustomerService?corpId=ww4ef6780d1fe31a5f&url=${encodeURIComponent(AD_FREE_SERVICE)}`
  } else {
    windowOpen(AD_FREE_SERVICE)
  }
  // if (useragent.isSuishouji) {
  //   window.location.href = `https://t.feidee.com/wxCustomerService?corpId=ww4ef6780d1fe31a5f&url=${SSJ_SERVICE_URL}`
  // } else if (useragent.isKaniu) {
  //   const url = `${domain.feideeRes}/cab-gold-card/index.html#/outlink?url=${encodeURIComponent(KN_SERVICE_URL)}`
  //   window.location.href = `https://t.cardniu.com/applyloan?url=${encodeURIComponent(url)}`
  // } else {
  //   windowOpen(SSJ_SERVICE_URL)
  // }
}

export const getChannelType = (partnerCode: string) => {
  const reg = /(^huawei$)|(^huaweipro$)/i
  if (reg.test(partnerCode) && useragent.isAndroid) {
    return 'huawei'
  } else if (useragent.isIOS) {
    return 'ios'
  } else {
    return 'other'
  }
}

/**
 * 支付方式
 * @param partnerCode
 * @return {Number}
 */
export const fetchPayType = (partnerCode: string) => {
  const regChannel = /(^huawei$)|(^huaweipro$)/i
  if (regChannel.test(partnerCode) && useragent.isAndroid) {
    return HUAWEI_PAY // 华为支付
  } else if (useragent.isIOS) {
    return APPLE_PAY // 苹果支付
  } else {
    return WX_APP_PAY // 微信app支付
  }
}
